import { appType } from "@/shared/lib/appType";

/**
 * iOS 진입 자동 키보드 브리지(FE 어댑터) — backBridge 동형.
 *
 * iOS WKWebView 는 사용자 제스처 밖의 프로그래매틱 focus() 에 DOM focus(테두리)만 주고
 * 소프트 키보드를 억제한다. 네이티브(make-trand-ios)가 requestKeyboardFocusHandler 를 수신하면
 * evaluateJavaScript 로 window.__focusEntryField() 를 동기 호출하고, 그 eval 스코프
 * (m_userIsInteracting on — WebKit 243416 / iOS 16.4+ SDK 링크 공개 API)에서 실행되는 첫 focus()
 * 가 키보드를 올린다. 이 파일은 "네이티브 지원 여부 판정" 과 "요청 post" 만 담당한다.
 * 보안(isMainFrame + trustedBridgeHosts)은 네이티브 중앙 라우터가 강제하므로 FE 는 post 만 한다.
 */

/**
 * iOS 신네이티브(requestKeyboardFocusHandler 등록됨)에서만 true.
 * WKWebView 는 등록된 message handler 만 window.webkit.messageHandlers 에 노출하므로 이 존재
 * 판정이 신/구 네이티브 빌드를 정확히 구분한다(구빌드=undefined → 호출처가 el.focus() 폴백).
 */
export const isNativeKeyboardFocusSupported = (): boolean =>
  appType() === "iOS" &&
  typeof window.webkit?.messageHandlers?.requestKeyboardFocusHandler?.postMessage ===
    "function";

/**
 * 네이티브에 "진입 필드 키보드 focus" 를 요청한다(단순 ping — payload 는 네이티브가 무시).
 * 수신한 네이티브가 window.__focusEntryField() 를 동기 호출한다. 호출 전 window.__focusEntryField
 * 가 등록돼 있어야 한다(useAutoFocusOnEnter 가 정착 시 등록).
 */
export const requestNativeKeyboardFocus = (): void => {
  window.webkit?.messageHandlers?.requestKeyboardFocusHandler?.postMessage("");
};
